import { useState, useEffect, ReactElement } from "react";
import { Box, Chip } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import CurrentSession from "data/userSession";

interface IncognitoGuardProps {
  children: ReactElement;
}

const IncognitoGuard = ({ children }: IncognitoGuardProps) => {
  const [isIncognito, setIsIncognito] = useState<boolean | null>(null);

  useEffect(() => {
    CurrentSession.load().then((user) => {
      setIsIncognito(user.incognito ?? false);
    });
  }, []);

  if (isIncognito === null) return null; // Loading

  if (isIncognito) {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <Chip
          icon={<ErrorOutline />}
          color="error"
          label="Incognito mode disables this feature"
        />
      </Box>
    );
  }

  return children;
};

export default IncognitoGuard;
